import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    AfterViewInit,
    ViewChild,
    Renderer,
    ElementRef, OnDestroy
} from '@angular/core';
import {
    AlertController,
    App,
    Content,
    Events, LoadingController,
    NavController,
    NavParams,
    Slides,
    ToastController,
    ViewController
} from "ionic-angular";
import { LotteryService } from "../../services/lottery.services";
import { TranslateService } from "ng2-translate";

import * as TaiXiu from "../../+lotteryFace/taixiuFace";
import { AppDialog } from "../../component/appDialog";
import { TaixiuServices } from "../../services/taixiu.services";
import { LotteryPage } from "../lottery/lottery";
import { CommonService } from "../../services/common.service";
import { RecordListPage } from "../recordList/recordList";
import { HomePage } from "../home/home";
import { LoginPage } from '../login/login';
@Component({
    selector: 'tai-xiu-page',
    templateUrl: 'TaiXiuPage.html',
})
export class TaiXiuPage implements OnInit, AfterViewInit, OnDestroy {
    private dropPanelHidden: boolean = true;
    private eventsSubscription: any = null;

    @ViewChild(Content) content: Content;
    @ViewChild(Slides) slides: Slides;
    private planeTitle: string = '';
    private lotteryType: string;
    private gameId: number;
    private taixiuFaces: any;
    private lotteryFn = {
        'MMC': () => this.taixiuFaces = TaiXiu.taixiuFace(this.translate), // 1 giay
        'tx1phut': () => this.taixiuFaces = TaiXiu.taixiuFace(this.translate), // 1 phut
    };
    public subIDFace: string = '';
    public balanceCurrent: any;
    public totalMoneyChip: number = 0;
    static betMoney: number = 0;
    public dataGetChipBet: any = {
        money: 0,
        gameid: 0,
        betdata: {}
    };
    public betdataArr: any = [];
    public typeBetCurrent: string;
    public FACE: any;
    public taixiuTypeFACE = {
        'txcl': () => this.FACE = TaiXiu.taixiuchanleFace(this.translate),
        'bddn': () => this.FACE = TaiXiu.bodoidongnhatFace(this.translate),
        'bbdn': () => this.FACE = TaiXiu.bobadongnhatFace(this.translate),
        'ct': () => this.FACE = TaiXiu.cuoctongFace(this.translate),
        'cc': () => this.FACE = TaiXiu.cuoccapFace(this.translate),
        'c1so': () => this.FACE = TaiXiu.cuoc1SoFace(this.translate),
    };
    public getElBtn: any;
    public getNameEachBet = [];
    public moneyLostWin: number = 0;
    public strWinorLost: string = '-';
    private goIssues: any = {
        isGo: false
    };
    public pageDome: HTMLElement;
    public storeDataWin: any;
    public dataTaiXiuWin: any;
    public is1Giay: boolean = false;
    public getArrHistoryApi: any;
    public getArrHistoryLimit: any = [];
    public getArrMethodsApi: any;
    private openRecordPanelShow: boolean = false;
    public gameNameTitle: string = '';
    public gameNameNote: string = '';
    public isEmptyHistory: boolean = false;
    public configUiChip: any;
    public timeoutGroupChip = null;
    public timeoutHideChip = null;
    // for 1 phut tai xiu
    public currentIssue: string;
    public countTime: string;
    static countTimer: any;
    private toggleHTimeResult: boolean = true;
    private coutTimeoutResult: any;
    private coutTimeResult: string = '00:00:00';
    public titleStoreBtn: string = '';
    private topResultDetails: any;
    private topResult: any;
    private scrollTop: number = 0;


    public chipbetList: any = [
        {
            name: "chip1",
            chipVal: "1000",
            title: "1K",
            status: "1",
            src: "build/assets/images/xocdia/chip1.png"
        },
        {
            name: "chip2",
            chipVal: "2000",
            title: "2K",
            status: "0",
            src: "build/assets/images/xocdia/chip2.png"
        },
        {
            name: "chip3",
            chipVal: "5000",
            title: "5K",
            status: "0",
            src: "build/assets/images/xocdia/chip3.png"
        },
        {
            name: "chip4",
            chipVal: "10000",
            title: "10K",
            status: "0",
            src: "build/assets/images/xocdia/chip4.png"
        },
        {
            name: "chip5",
            chipVal: "20000",
            title: "20K",
            status: "0",
            src: "build/assets/images/xocdia/chip5.png"
        },
        {
            name: "chip6",
            chipVal: "50000",
            title: "50K",
            status: "0",
            src: "build/assets/images/xocdia/chip6.png"
        },
        {
            name: "chip7",
            chipVal: "100000",
            title: "100K",
            status: "0",
            src: "build/assets/images/xocdia/chip7.png"
        },
        {
            name: "chip8",
            chipVal: "200000",
            title: "200K",
            status: "0",
            src: "build/assets/images/xocdia/chip8.png"
        },
        {
            name: "chip9",
            chipVal: "500000",
            title: "500K",
            status: "0",
            src: "build/assets/images/xocdia/chip9.png"
        },
        {
            name: "chip10",
            chipVal: "1000000",
            title: "1M",
            status: "0",
            src: "build/assets/images/xocdia/chip7.png"
        },
        {
            name: "chip11",
            chipVal: "2000000",
            title: "2M",
            status: "0",
            src: "build/assets/images/xocdia/chip6.png"
        }

    ];

    constructor(public navCtrl: NavController, private app: App, public navParams: NavParams, public renderer: Renderer, public viewCtrl: ViewController,
        private lotteryService: LotteryService, private toastCtrl: ToastController, private taixiuService: TaixiuServices, private alertCtrl: AlertController,
        private events: Events, public el: ElementRef, private commonSV: CommonService, public loadingCtrl: LoadingController, 
        public translate: TranslateService  ) {
        this.gameNameTitle = navParams.data['titleGame'];
        this.gameNameNote = navParams.data['title'];
        this.pageDome = el.nativeElement;
        this.lotteryType = navParams.data["lotteryName"];
        this.lotteryType === 'MMC' ? this.is1Giay = true : this.is1Giay = false;
        this.lotteryFn[this.lotteryType]();
        this.dataGetChipBet.gameid = this.gameId = navParams.data["lotteryId"];
        if (LoginPage.cytype != 1) {
            this.chipbetList = [
                {
                    name: "chip1",
                    chipVal: "1",
                    title: "1",
                    status: "1",
                    src: "build/assets/images/xocdia/chip1.png"
                },
                {
                    name: "chip2",
                    chipVal: "2",
                    title: "2",
                    status: "0",
                    src: "build/assets/images/xocdia/chip2.png"
                },
                {
                    name: "chip3",
                    chipVal: "5",
                    title: "5",
                    status: "0",
                    src: "build/assets/images/xocdia/chip3.png"
                },
                {
                    name: "chip4",
                    chipVal: "10",
                    title: "10",
                    status: "0",
                    src: "build/assets/images/xocdia/chip4.png"
                },
                {
                    name: "chip5",
                    chipVal: "20",
                    title: "20",
                    status: "0",
                    src: "build/assets/images/xocdia/chip5.png"
                },
                {
                    name: "chip6",
                    chipVal: "50",
                    title: "50",
                    status: "0",
                    src: "build/assets/images/xocdia/chip6.png"
                },
                {
                    name: "chip7",
                    chipVal: "100",
                    title: "100",
                    status: "0",
                    src: "build/assets/images/xocdia/chip7.png"
                },
                {
                    name: "chip8",
                    chipVal: "200",
                    title: "200",
                    status: "0",
                    src: "build/assets/images/xocdia/chip8.png"
                },
                {
                    name: "chip9",
                    chipVal: "500",
                    title: "500",
                    status: "0",
                    src: "build/assets/images/xocdia/chip9.png"
                },
                {
                    name: "chip10",
                    chipVal: "1000",
                    title: "1K",
                    status: "0",
                    src: "build/assets/images/xocdia/chip7.png"
                },
                {
                    name: "chip11",
                    chipVal: "2000",
                    title: "2K",
                    status: "0",
                    src: "build/assets/images/xocdia/chip6.png"
                }

            ];
        }
        // get balance
        this.getBalanceCurrent();
        // event pass from page trace
        this.events.subscribe('taixiu:CloseJumpEmu', data => {
            // console.log('CloseJumpEmu', data);
            this.processBetTaiXiu();
        });


    }
    ionViewWillEnter() {
        if (this.eventsSubscription == null) {
            this.eventsSubscription = this.events.subscribe('taixiu:Clean', (data) => {
                // console.log('Sự kiện nhận:', data);
                this.cancelbet(true);
            });
        }

    }
    ionViewDidLeave() {
        if (this.eventsSubscription) {
            this.eventsSubscription.unsubscribe(); // Hủy đăng ký sự kiện
            this.eventsSubscription = null; // Đặt lại giá trị
        }
    }
    getBalanceCurrent() {
        this.lotteryService.lotteryBalance({}, null).then(data => {
            if (data["balance"]) {
                this.balanceCurrent = this.commonSV.numberWithCommas(data['balance']);
            }
        });
    }

    getHistorys1Giay() {
        if (this.is1Giay) { // is 1giay
            let params = { lotteryId: this.dataGetChipBet.gameid };
            this.taixiuService.diceInit(params, this).then(data => {
            
                if (data) {
                    this.getArrHistoryApi = eval(data['history']);
                    this.historyBetTop();
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    historyBetTop() {
        if (this.getArrHistoryApi.length <= 0) {
            this.isEmptyHistory = true;
            return;
        }

        // reset this.getArrHistoryLimit
        this.getArrHistoryLimit = [];

        this.getArrHistoryApi.map((item, idx) => {
            this.isEmptyHistory = false;
            if (idx < 10) {
                let getDate = this.commonSV.convertTimeZoneVN(new Date(item['finishtime'].substring(0, 10)), 'DD/MM/YYYY');
                let getTime = item['finishtime'].substr(11);
                item['finishtime'] = getDate + ' ' + getTime;
                item['detail'] = item['detail'].split('|');
                item['detail'].sort();
                let totalDice = Number(item['detail'][0]) + Number(item['detail'][1]) + Number(item['detail'][2]);
                Number(item['detail'][0]) == Number(item['detail'][1]) && Number(item['detail'][0]) == Number(item['detail'][2]) ? (item['daxiaoCls'] = "sign-baozi", item['daxiaoText'] = "-", item['danshuangCls'] = "sign-baozi", item['danshuangText'] = "-") : (totalDice > 10 ? (item['daxiaoCls'] = "sign-big", item['daxiaoText'] = "T") : (item['daxiaoCls'] = "sign-small", item['daxiaoText'] = "X"), totalDice % 2 == 1 ? (item['danshuangCls'] = "sign-odd", item['danshuangText'] = "L") : (item['danshuangCls'] = "sign-even", item['danshuangText'] = "C"));
                this.getArrHistoryLimit.push(item);
            }
        });
    }

    ngOnInit() {
        this.bindEvent();
        this.content.ionScroll.subscribe((data) => {
            this.scrollTop = data.scrollTop;
        });
    }


    ngAfterViewInit() {
        let taBarDom = this.navCtrl.parent._elementRef.nativeElement.querySelector('div.tabbar');
        let addDom = document.createElement('div');
        addDom.setAttribute("tappable", "");
        addDom.className = "submit";
        addDom.innerText = this.translate.instant('TAIXIU_PAGE.BET');
        addDom.id = "lottery-submit";
        taBarDom.appendChild(addDom);
        addDom.addEventListener('click', () => {
            this.taixiuBet();
        });
    }

    dismiss() {
        clearInterval(TaiXiuPage.countTimer);
        let tabsRoot = this.app.getRootNav();
        tabsRoot.pop();
    }

    toggleGamePanel() {
        this.dropPanelHidden = !this.dropPanelHidden;
        let taBarDom: HTMLElement = this.navCtrl.parent._elementRef.nativeElement.querySelector('div.tabbar');
        if (!this.dropPanelHidden) {
            taBarDom.setAttribute("hidden", !this.dropPanelHidden + "");
        } else {
            taBarDom.removeAttribute("hidden");
        }
        this.content.resize();
    }

    selectActiveLottery(activeLottery: any) {
        if (this.totalMoneyChip > 0) this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g, '')) + this.totalMoneyChip);
        // ph
        this.resetDataChipBet();
        this.cancelbet(true);

        this.planeTitle = activeLottery.title;
        this.subIDFace = activeLottery.activeLottery.subIDFace;

        this.taixiuTypeFACE[this.subIDFace]();

        // first reset
        this.getNameEachBet = [];

        if (this.subIDFace === 'txcl') {
            this.FACE.map(item => {
                this.getNameEachBet.push(item.name);
            });
        } else if (this.subIDFace === 'bddn' || this.subIDFace === 'bbdn') {
            this.FACE.map(face => {
                face.betsItem.map(item => {
                    this.getNameEachBet.push(item.name);
                });
            });
        } else if (this.subIDFace === 'cc' || this.subIDFace === 'c1so') {
            this.FACE.betsBlock.map(item => {
                item.itemsBlock.map(itemsBlock => {
                    this.getNameEachBet.push(item.name);
                });
            });
        } else if (this.subIDFace === 'ct') {
            this.FACE.betsItem.map(item => {
                this.getNameEachBet.push(item.name);
            });
        }
    }

    /**
     * Output event from dropSelectPanel.ts
     * @param initParams
     */
    onLotteryAfter(initParams: any) {
        LotteryPage.lotteryId = initParams["lotteryid"];
        this.configUiChip = initParams['chips'];
        this.getArrHistoryApi = initParams['history'];
        if (!this.is1Giay) { // is 1phut
            this.currentIssue = initParams['issue'];
            this.setOpenTime(initParams["endtime"], initParams["servertime"], initParams["opentime"]);
            this.getHistory1Phut();
        } else { // is 1giay
            this.historyBetTop();
        }
    }

    setOpenTime(endtime: string, servertime: string, opentime: string) {
        let pourTime: number = (+new Date(endtime.replace(/-/g, "/")) - +new Date(servertime.replace(/-/g, "/"))) / 1000;
        clearInterval(TaiXiuPage.countTimer);
        TaiXiuPage.countTimer = setInterval(() => {
            pourTime--;
            if (pourTime >= 0) {
                let hour: any = parseInt((pourTime / 3600).toString());
                let minute: any = parseInt(((pourTime - hour * 3600) / 60).toString());
                let second: any = parseInt((pourTime % 60).toString());
                if (hour < 10) {
                    hour = "0" + hour;
                }
                if (minute < 10) {
                    minute = "0" + minute;
                }
                if (second < 10) {
                    second = "0" + second;
                }
                this.countTime = hour + ":" + minute + ":" + second;
            }
            if (pourTime === -1) {


                this.toggleHTimeResult = false;
                this.timerShowResult(opentime, endtime, () => {
                    this.toggleHTimeResult = true;
                });
                this.goNextIusse1Phut();
                clearInterval(TaiXiuPage.countTimer);
            }
        }, 1000);
    }

    timerShowResult(opentime, servertime, callBackFun) {
        let pourTime: number = (+new Date(opentime.replace(/-/g, "/")) - +new Date(servertime.replace(/-/g, "/"))) / 1000;

        clearInterval(this.coutTimeoutResult);
        this.coutTimeoutResult = setInterval(() => {
            pourTime--;
            if (pourTime >= 0) {
                let hour: any = parseInt((pourTime / 3600).toString());
                let minute: any = parseInt(((pourTime - hour * 3600) / 60).toString());
                let second: any = parseInt((pourTime % 60).toString());
                if (hour < 10) {
                    hour = "0" + hour;
                }
                if (minute < 10) {
                    minute = "0" + minute;
                }
                if (second < 10) {
                    second = "0" + second;
                }
                this.coutTimeResult = hour + ":" + minute + ":" + second;
            }
            if (pourTime === -1) {
                //call check openwin
                this.getOpenRecord(this.currentIssue, 4)
                setTimeout(() => {
                    this.goNextIusse1Phut();
                }, 2000);
                clearInterval(this.coutTimeoutResult);
                callBackFun();
            }
        }, 1000);
    }

    goNextIusse1Phut() {
        this.getHistory1Phut();
        this.taixiuService.mDiceInit({}, null).then(data => {
            if (data) {
                let translateMessage = this.translate.instant('TAIXIU_PAGE.BET_SUCCESS');
                // this.storeDataWin = JSON.parse('{   "data": {     "balance": "5862340",     "details": [       "xiao",       "dan",       "hezhi_9",       "erma_32",       "erma_34",       "erma_24",       "yima_3",       "yima_2",       "yima_4"     ],     "prize": "0",     "result": "3|4|2"   },   "msg": ' + translateMessage + ',   "success": 1,   "type": "success" }');
                this.storeDataWin = JSON.parse('{   "data": {     "balance": "5862340",     "details": [       "xiao",       "dan",       "hezhi_9",       "erma_32",       "erma_34",       "erma_24",       "yima_3",       "yima_2",       "yima_4"     ],     "prize": "0",     "result": "3|4|2"   },   "msg": "Đặt cược thành công",   "success": 1,   "type": "success" }');


                let opentime = data['data']["cursitem"]["opentime"];
                let endtime = data['data']["cursitem"]["endtime"];
                let servertime = data['data']["servertime"];
                this.setOpenTime(endtime, servertime, opentime);
                this.currentIssue = data['data']["cursitem"]["issue"];

                let userbalance = data['data']['userbalance'];
                // this.balanceCurrent = this.commonSV.numberWithCommas(userbalance);

                if (this.toggleHTimeResult == true) {

                    var returnData = {
                        "data": {
                            "balance": userbalance,
                            "details": this.topResultDetails,
                            "prize": "0",
                            "result": this.topResult
                        },
                        "msg": translateMessage,
                        "success": 1,
                        "type": "success"
                    };
                    console.log('returnData',returnData);
                    
                    this.storeDataWin = returnData;
                    this.dataTaiXiuWin = {
                        dataApi: this.storeDataWin,
                        goIssues: false
                    };
                    this.resetDataChipBet();
                }
                //  this.getBalanceCurrent();

            }
        }).catch(error => {
            console.log(error);
        });
    }

    getHistory1Phut() {
        // reset this.getArrHistoryLimit
        this.getArrHistoryLimit = [];

        let params = {
            sid: this.gameId,
            num: 20
        };
        this.taixiuService.mDiceHistoryTop(params, null).then(data => {
            let getData = data['data'];
            console.log("getData", getData[0]);
            this.topResultDetails = getData[0].details;
            this.topResult = getData[0].winnumberarr.join("|");
            getData.map(item => {
                let objTemp = {};
                item.winnumber.split(',').length > 1 ? objTemp['detail'] = item.winnumber.split(',').sort() : objTemp['detail'] = item.winnumber.split('').sort();
                let winItem = objTemp['detail'];
                let totalDice = Number(winItem[0]) + Number(winItem[1]) + Number(winItem[2]);
                Number(winItem[0]) == Number(winItem[1]) && Number(winItem[0]) == Number(winItem[2]) ? (objTemp['daxiaoCls'] = "sign-baozi", objTemp['daxiaoText'] = "-", objTemp['danshuangCls'] = "sign-baozi", objTemp['danshuangText'] = "-") : (totalDice > 10 ? (objTemp['daxiaoCls'] = "sign-big", objTemp['daxiaoText'] = "T") : (objTemp['daxiaoCls'] = "sign-small", objTemp['daxiaoText'] = "X"), totalDice % 2 == 1 ? (objTemp['danshuangCls'] = "sign-odd", objTemp['danshuangText'] = "L") : (objTemp['danshuangCls'] = "sign-even", objTemp['danshuangText'] = "C"));
                objTemp['finishtime'] = item.issue;
                this.getArrHistoryLimit.push(objTemp);
            });
        }).catch(error => {
            console.log(error);
        });
    }

    evElSelectChip(eventInput: any) {

        if (eventInput && this.getElBtn) {
            if (Number(this.balanceCurrent.replace(/[,]/g, '')) < Number(eventInput.moneyChip)) {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('TAIXIU_PAGE.BALANCE_NOT_ENOUGH')
                });
            } else {
                this.totalMoneyChip += Number(eventInput.moneyChip);
                let addChip = '<span class="' + eventInput.chipClass + '"></span>';
                this.getElBtn.insertAdjacentHTML('beforeend', addChip);
                let elChip = this.getElBtn.querySelectorAll('.chip');
                let zIndexChipFirst = 100;
                let mgTopChipFirst = 27;
                this.dataGetChipBet.money = this.totalMoneyChip;
                for (let i = 0, len = elChip.length; i < len; i++) {
                    if (i === 0) continue;
                    elChip[i].style.zIndex = zIndexChipFirst + i;
                    elChip[i].style.marginTop = "-" + (mgTopChipFirst + i * 3) + "px";
                }
                if (this.betdataArr[this.typeBetCurrent] === undefined) {
                    this.betdataArr[this.typeBetCurrent] = {};
                    this.betdataArr[this.typeBetCurrent].title = this.titleStoreBtn;
                    this.betdataArr[this.typeBetCurrent].totalMoney = 0;
                }
                this.betdataArr[this.typeBetCurrent].totalMoney += Number(eventInput.moneyChip);
                this.dataGetChipBet.betdata = this.convertDataArrayToObject(this.betdataArr);
                // ph
                // this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g,'')) - Number(eventInput.moneyChip));
            }
            TaiXiuPage.betMoney = this.totalMoneyChip;
        }
    }
    ionViewWillLeave() {
        TaiXiuPage.betMoney = this.totalMoneyChip;
    }


    selectChip(event: any, item: any) {

        for (let chip of this.chipbetList) {
            if (chip.name === item.name) {
                chip.status = '1';
                continue;
            }
            chip.status = '0';
        }


    }

    initData(data: any) {
        // init list chip
        let chips: any = JSON.parse(data["chips"]);
        // reset list chip
        let templist = [];
        chips.forEach(function (item, index) {
            item.name = "chip" + (index + 1);
            item.src = "build/assets/images/xocdia/" + item.name + ".png";
            templist.push(item);
        });
        this.chipbetList = templist;

        // // init list model
        let model = data['model'];

        // if (model.length !== this.xocdiaface.length) {
        //     AppDialog.toast({
        //         toastCtrl: this.toastCtrl,
        //         message: 'Model không hợp lệ!',
        //         fn: () => {
        //             let tabsRoot = this.app.getRootNav();
        //             tabsRoot.pop();
        //         }
        //     });
        // }else {
        //     model = model.map((item, index) => {
        //         item['level1'] = (item['level1'] - 1).toString();
        //         this.xocdiaface = this.xocdiaface.map(itemFace => {
        //             if (itemFace['methodname'] === item['methodname']) {
        //                 itemFace['odds'] += item['level1'];
        //             }
        //             return itemFace;
        //         });

        //         return {
        //             level1: item['level1'],
        //             levelnum: item['levelnum'],
        //             maxbet: item['maxbet'],
        //             methodname: item['methodname'],
        //             currentBet: 0,
        //             name: this.xocdiaface.find(itemFace => itemFace['methodname'] === item['methodname']).name
        //         };
        //     });
        //     this.modelList = model;
        // }

        // // init 1m
        // if (!this.is1Giay) {
        //     this.currentIssue = data["curissue"]["issue"];
        //     let endtime = data["curissue"]["endtime"];
        //     let servertime = data["servertime"];
        //     let pourTime: number = (+new Date(endtime.replace(/-/g, "/")) - +new Date(servertime.replace(/-/g, "/"))) / 1000;
        //     if (pourTime < 0) {
        //         return;
        //     }
        //     this.setOpenTime(endtime, servertime, pourTime);
        //     this.getHistory1Phut();
        // }

    }


    convertDataArrayToObject(arr: any) {
        let obj = {};
        for (let item in arr) {
            obj[item] = arr[item];
        }
        return obj;
    }

    goToSlide(number: any) {
        if (Math.abs(number - this.slides.getActiveIndex()) > 0)
            this.slides.slideTo(number, 0);
    }
    groupChip(list: any) {
        let totalMoneyinChip = 0;
        this.timeoutGroupChip = setTimeout(() => {
            list.forEach(element => {
                let currentModel = this.chipbetList.find(model => model.methodname === element.getAttribute('methodname'));
                totalMoneyinChip += Number(element.getAttribute('currency'));
                // totalMoneyinChip = totalMoneyinChip > currentModel.maxbet ? currentModel.maxbet : totalMoneyinChip;
                var title: any = totalMoneyinChip;
                if (totalMoneyinChip > 4000) {
                    title = String(totalMoneyinChip / 1000) + "K"
                } else {
                    title = totalMoneyinChip;
                }


                element.querySelector('.txtbet').innerHTML = title;
            });
        }, 310);
    }
    selectBet(event: any, name: string, title: string) {

        this.getElBtn = event.target;
        if (event.target.nodeName !== 'BUTTON') {
            this.getElBtn = event.target.closest('.button-ios');
        }
        // show chips select
        // this.toggleChipsPopup(true);
        // end show chips select

        this.titleStoreBtn = title.toLowerCase();
        this.typeBetCurrent = name;
        // if (this.betdataArr[this.typeBetCurrent] === undefined) {
        //     this.betdataArr[this.typeBetCurrent] = {};
        //     this.betdataArr[this.typeBetCurrent].title = this.titleStoreBtn;
        //     this.betdataArr[this.typeBetCurrent].totalMoney = 0;
        // }


        // -------- phat
        let indexChip = this.chipbetList.findIndex((chip) => chip.status == 1);
        let maxChip = 6;
        let activeChip = this.pageDome.querySelector('.chipbetBtn.active');
        if (activeChip == null) {
            console.log('chon chip')
            return;
        }
        // let chipCurrency = Number(activeChip.getAttribute('value'))* 1000;
        let chipCurrency = Number(activeChip.getAttribute('value'));
        this.totalMoneyChip += chipCurrency;
        // console.log("vao totalMoneyChip", this.totalMoneyChip);
        let parentDiv = document.querySelector('.cls-wrapper');
        let cloneChip = document.createElement('span');
        cloneChip.innerHTML = activeChip.innerHTML;
        // const body = document.getElementById("wrapper");
        const body = document.querySelector(".taixiuWrapper");
        // Get the bounding rectangle of the body
        const bodyRect = body.getBoundingClientRect();

        // Calculate the left distance from the body to the full screen
        const leftDistance = bodyRect.left;
        cloneChip.style.position = "absolute";
        // cloneChip.style.top = (activeChip.getBoundingClientRect().top*1.1 + this.scrollTop) + 'px';
        cloneChip.style.top = (activeChip.getBoundingClientRect().top - activeChip.getBoundingClientRect().height + this.scrollTop) + 'px';

        cloneChip.style.left = activeChip.getBoundingClientRect().left - leftDistance + 'px';
        cloneChip.style.width = activeChip.getBoundingClientRect().width + 'px';
        cloneChip.style.height = activeChip.getBoundingClientRect().height + 'px';

        // console.log('====================================');
        // console.log('cloneChip.style.top', cloneChip.style.top);
        // console.log('====================================');
        // if (this.subIDFace == 'txcl') {
        //     cloneChip.style.width = activeChip.getBoundingClientRect().width*0.8 + 'px';
        //     cloneChip.style.height = activeChip.getBoundingClientRect().height*0.8 + 'px';
        // }
        if (this.subIDFace == 'bddn' || this.subIDFace == 'bbdn') {
            cloneChip.style.width = activeChip.getBoundingClientRect().width * 0.7 + 'px';
            cloneChip.style.height = activeChip.getBoundingClientRect().height * 0.7 + 'px';
        }
        if (this.subIDFace == 'ct') {
            cloneChip.style.width = activeChip.getBoundingClientRect().width * 0.66 + 'px';
            cloneChip.style.height = activeChip.getBoundingClientRect().width * 0.66 + 'px';
        }
        if (this.subIDFace == 'cc') {
            cloneChip.style.width = activeChip.getBoundingClientRect().width * 0.5 + 'px';
            cloneChip.style.height = activeChip.getBoundingClientRect().width * 0.5 + 'px';
        }
        if (this.subIDFace == 'c1so') {
            cloneChip.style.width = activeChip.getBoundingClientRect().width * 0.6 + 'px';
            cloneChip.style.height = activeChip.getBoundingClientRect().width * 0.6 + 'px';
        }

        cloneChip.style.zIndex = "3";
        cloneChip.classList.add('chipbetBtn');
        cloneChip.classList.add('chipEmbed');
        cloneChip.classList.add('chipbetBtn-clone');
        cloneChip.classList.add(name);
        cloneChip.setAttribute('methodname', name);
        cloneChip.setAttribute('currency', chipCurrency.toString());
        parentDiv.appendChild(cloneChip);
        let ListCloneChips = document.querySelectorAll('.chipEmbed.' + name);
        let lastEl = <HTMLElement><any>ListCloneChips[ListCloneChips.length - 2];
        if (ListCloneChips.length > 1 && ListCloneChips.length < maxChip) {
            let getZIndexLastOld = Number(lastEl.style.zIndex) + 1;
            cloneChip.style.zIndex = "" + getZIndexLastOld + "";
        }
        else if (ListCloneChips.length >= maxChip) {
            let getZIndexLastOld = Number(lastEl.style.zIndex) + 1;
            cloneChip.style.zIndex = "" + getZIndexLastOld + "";
            this.groupChip(ListCloneChips);
        }

        let offset = ListCloneChips.length > maxChip ? maxChip : ListCloneChips.length;
        const chipHeight = activeChip.getBoundingClientRect().height;
        const chipWidth = activeChip.getBoundingClientRect().width;
        cloneChip.style.top =
            (event.currentTarget.getBoundingClientRect().top
                + (event.currentTarget.getBoundingClientRect().height / 2)
                - (Number(chipHeight))
                + this.scrollTop
                - (offset * 4)) + 'px';

        cloneChip.style.left =
            event.currentTarget.getBoundingClientRect().left
            - leftDistance
            + (event.currentTarget.getBoundingClientRect().width / 2)
            - (Number(activeChip.getBoundingClientRect().width) / 2)
            + 'px';

        //old
        // let offset = ListCloneChips.length > maxChip ? maxChip : ListCloneChips.length;
        // Lấy thông tin bounding box của container (hoặc viewport)
        //  const containerRect = event.currentTarget.getBoundingClientRect();

        // console.log(chipHeight, chipWidth);
        // // Tính toán vị trí top và left để chip luôn nằm ở giữa
        //  cloneChip.style.top = (containerRect.top + containerRect.height - chipHeight + this.scrollTop) - (offset * 4) + 'px';
        //  cloneChip.style.left = (containerRect.left + containerRect.width / 2 - chipWidth / 2) + 'px';

        // if (this.subIDFace == 'bddn') {
        //     cloneChip.style.top = (event.currentTarget.getBoundingClientRect().top + this.scrollTop - (offset * 4)) + 'px';
        // }
        if (this.subIDFace == 'bbdn') {
            cloneChip.style.left =
                event.currentTarget.getBoundingClientRect().left
                - leftDistance
                + (event.currentTarget.getBoundingClientRect().width / 2)
                - (Number(activeChip.getBoundingClientRect().width) / 2)
                + 10
                + 'px';
        }
        if (this.subIDFace == 'ct') {
            // cloneChip.style.top = (event.currentTarget.getBoundingClientRect().top
            //     + (event.currentTarget.getBoundingClientRect().height / 2)
            //     - (Number(chipWidth) / 2)
            //     + this.scrollTop
            //     + 15
            //     - (offset * 4)) + 'px';
            cloneChip.style.left =
                event.currentTarget.getBoundingClientRect().left
                - leftDistance
                + (event.currentTarget.getBoundingClientRect().width / 2)
                - (Number(activeChip.getBoundingClientRect().width) / 2)
                + 8
                + 'px';
        }
        if (this.subIDFace == 'cc') {
            // cloneChip.style.top = (event.currentTarget.getBoundingClientRect().top
            //     + (event.currentTarget.getBoundingClientRect().height / 2)
            //     - (Number(chipWidth) / 2)
            //     + this.scrollTop
            //     + 20
            //     - (offset * 4)) + 'px';
            cloneChip.style.left =
                event.currentTarget.getBoundingClientRect().left
                - leftDistance
                + (event.currentTarget.getBoundingClientRect().width / 2)
                - (Number(activeChip.getBoundingClientRect().width) / 2)
                + 13
                + 'px';
        }
        if (this.subIDFace == 'c1so') {
            // cloneChip.style.top = (event.currentTarget.getBoundingClientRect().top
            //     + (event.currentTarget.getBoundingClientRect().height / 2)
            //     - (Number(chipWidth) / 2)
            //     + this.scrollTop
            //     + 20
            //     - (offset * 4)) + 'px';
            cloneChip.style.left =
                event.currentTarget.getBoundingClientRect().left
                - leftDistance
                + (event.currentTarget.getBoundingClientRect().width / 2)
                - (Number(activeChip.getBoundingClientRect().width) / 2)
                + 10
                + 'px';
        }

        // xử lý bet total
        this.dataGetChipBet.money = this.totalMoneyChip;
        if (this.betdataArr[this.typeBetCurrent] === undefined) {
            this.betdataArr[this.typeBetCurrent] = {};
            this.betdataArr[this.typeBetCurrent].title = this.titleStoreBtn;
            this.betdataArr[this.typeBetCurrent].totalMoney = 0;
        }

        this.betdataArr[this.typeBetCurrent].totalMoney += Number(chipCurrency);
        this.dataGetChipBet.betdata = this.convertDataArrayToObject(this.betdataArr);
    }

    /**
     * @param flag: true = show, false = hide
     */
    toggleChipsPopup(flag) {
        let elSelectChip = this.pageDome.querySelector('select-chip');
        if (flag) {
            elSelectChip.classList.add('showChip');
            setTimeout(() => {
                elSelectChip.classList.add('active');
            }, 200);
        } else {
            elSelectChip.classList.remove('active');
            setTimeout(() => {
                elSelectChip.classList.remove('showChip');
            }, 200);
        }
    }

    clearChips(event: any) {
        if (event.data === 'clearAllChips') {
            this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g, '')) + this.totalMoneyChip);
            this.resetDataChipBet();
        } else if (event.data === 'closeSelectChips') {
            for (let key in this.dataGetChipBet.betdata) {
                if (this.dataGetChipBet.betdata[key].totalMoney <= 0) {
                    delete this.dataGetChipBet.betdata[key];
                }
            }
        }
    }

    resetDataChipBet() {
        // reset total money chip
        this.totalMoneyChip = 0;
        TaiXiuPage.betMoney = 0;

        // reset each type bet
        this.betdataArr = [];

        // reset data form
        this.dataGetChipBet = {
            money: 0,
            betdata: {},
            gameid: this.gameId
        };

        // remove chips
        let elChips = this.pageDome.querySelectorAll('.taixiuWrapper .chipo');
        console.log('====================================');
        console.log('elChips',elChips);
        console.log('====================================');
        for (let i = 0, len = elChips.length; i < len; i++) elChips[i].remove();
    }

    /**
     */
    taixiuBet() {
        if (this.totalMoneyChip <= 0) {
            AppDialog.toast({
                toastCtrl: this.toastCtrl,
                message: "Vui lòng chọn cược !!!"
            });
        } else {
            this.toggleChipsPopup(false);

            let html = '<div class="listComfirmTaiXiu">';
            let objComfirm = this.dataGetChipBet.betdata;
            for (let key in objComfirm) {
                if (objComfirm[key].totalMoney <= 0) continue;
                let str = '';
                if (key.split('_')[1] !== undefined && this.subIDFace !== 'ct') {
                    str = key.split('_')[1].split('').join(',');
                } else if (key.split('_')[1] !== undefined && this.subIDFace === 'ct') {
                    str = key.split('_')[1];
                }
                html += '<p><span>[ ' + objComfirm[key].title + ' ' + str + ']</span> - ' + this.commonSV.numberWithCommas(objComfirm[key].totalMoney) + '</p>'
            }
            html += '</div>';

            let getIssueBet = '';
            if (!this.is1Giay) {
                getIssueBet = this.currentIssue;
            }

            let alertCmp = this.alertCtrl.create({
                title: this.translate.instant('TAIXIU_PAGE.CONFIRM') + getIssueBet + " ?",
                cssClass: 'bet-dialog',
                message: html,
                buttons: [
                    { text: this.translate.instant('TAIXIU_PAGE.CANCEL') },
                    {
                        text: this.translate.instant('TAIXIU_PAGE.OK'),
                        handler: data => {
                            this.submitBet();
                            return true;
                        }
                    }
                ]
            });
            alertCmp.present();
        }
    }

    /**
     * reformat data and submit form to Bet
     */
    submitBet() {
        // convert betdata object to betdata['..']
        for (let item in this.dataGetChipBet.betdata) {
            let strTemp = "betdata[" + item + "]";
            let strTempVal = this.dataGetChipBet.betdata[item].totalMoney;
            this.dataGetChipBet[strTemp] = strTempVal;
            delete this.dataGetChipBet.betdata[item];
        }
        delete this.dataGetChipBet.betdata;
        // end convert betdata object to betdata['..']

        // show money bet effect
        this.moneyLostWin = this.dataGetChipBet.money;
        this.effectShowHideByClass('.moneyLostWin', 'betMoney', 1000);
        // end show money bet effect



        if (!this.checkMoneyTrace()) {
            this.strWinorLost = '-';
            this.moneyLostWin = this.totalMoneyChip;
            this.effectShowHideByClass('.moneyLostWin', 'betMoney', 1000);
            this.processBetTaiXiu();
        }
    }

    /**
     * submit data bet to server
     */
    processBetTaiXiu() {
        if (this.is1Giay) { // bet for 1giay
            this.taixiuService.diceBet(this.dataGetChipBet, this).then(async data => {
                if (data['success']) {
                    this.storeDataWin = data;
                    // update balance when each trace complete
                    // ph
                    // this.balanceCurrent = this.commonSV.numberWithCommas(Number(data['data'].balance) - this.totalMoneyChip);
                    this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g, '')) - this.totalMoneyChip);
                    // this.resetDataChipBet();

                    // let dataNew = await this.getBalanceCurrentNew();
                    // this.balanceCurrent = this.commonSV.numberWithCommas(dataNew['balance']);
                    // console.log('====================================');
                    // console.log('this.balanceCurrent', this.balanceCurrent);
                    // console.log('====================================');
                    if (this.goIssues.isGo) { // is trace and then loop bet api
                        this.getHistorys1Giay();
                        // update balance 
                        // this.balanceCurrent = this.commonSV.numberWithCommas(Number(dataNew['balance'].replace(/[,]/g, '')) - this.totalMoneyChip);
                        this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g, '')) - this.totalMoneyChip);
                        // console.log('this.goIssues', this.goIssues);

                        this.events.publish('taixiu:trace', {
                            dataApi: data,
                            goIssues: this.goIssues
                        });
                    } else {
                        console.log("vao no go goIssues", this.goIssues);

                        this.dataTaiXiuWin = {
                            dataApi: data,
                            goIssues: this.goIssues
                        };
                        this.resetDataChipBet();
                    }
                } else {
                    AppDialog.toast({
                        toastCtrl: this.toastCtrl,
                        message: data['msg']
                    });
                }
            }).catch(error => {
                console.log(error);
            });
        } else { // bet for 1phut
            let dataPost = this.dataGetChipBet;
            dataPost.trace_if = 0;
            dataPost.total_nums = 1;
            dataPost.total_money = dataPost.money;
            delete dataPost.money;
            dataPost['buyitem[]'] = "{'money':" + dataPost.total_money + ", 'nums': 1, 'times': 1}";
            dataPost.issue_start = this.currentIssue;

            this.taixiuService.mDiceBet(dataPost, null).then(data => {
                if (data['status'] === 'success') {

                    this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g, '')) - this.totalMoneyChip);
                    this.resetDataChipBet();
                    AppDialog.toast({
                        toastCtrl: this.toastCtrl,
                        message: this.translate.instant('TAIXIU_PAGE.BET_SUCCESS')
                    });
                    this.cancelbet(true);
                } else {
                    this.cancelbet(true);
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: data['data']
                    });
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    /**
     * @param elClass: class or id
     * @param {string} classEffect: add class effect
     * @param {number} timeoutSet: time out remove class effect
     */
    effectShowHideByClass(elClass: any, classEffect: string, timeoutSet: number) {
        let elMoneyBet = this.pageDome.querySelector(elClass);
        elMoneyBet.classList.add(classEffect);
        setTimeout(() => {
            elMoneyBet.classList.remove(classEffect);
            this.strWinorLost = '-';
        }, timeoutSet);
    }
    effectShowHideByClassNone(elClass: any, classFist: string, classActive: string, flag: boolean, timeoutSet: number) {
        let elMoneyBet = this.pageDome.querySelector(elClass);
        if (flag) {
            elMoneyBet.classList.add(classFist);
            setTimeout(() => {
                elMoneyBet.classList.add(classActive);
            }, timeoutSet);
        } else {
            elMoneyBet.classList.remove(classActive);
            setTimeout(() => {
                elMoneyBet.classList.remove(classFist);
            }, timeoutSet);
        }
    }

    /**
     * listening event issues:go from page trace
     */
    bindEvent() {
        this.events.subscribe('issues:go', (userEventData) => {
            this.goIssues = userEventData;
        });
    }

    /**
     * Output event from diceJump.ts
     * @param event: pass data from diceJump.ts
     */
    closeAniDiceJump(event: any) {
        let data = this.storeDataWin;
        this.effectShowHideByClassNone('.diceJump', 'showDiceJump', 'active', false, 200);
        let oldBalance = this.balanceCurrent;
        let newBalance = this.balanceCurrent;
        this.lotteryService.lotteryBalance({}, null).then(async dataBalance => {
            if (dataBalance["balance"]) {
                newBalance = dataBalance['balance'];
                if (newBalance == oldBalance) {
                    let dataNew = await this.getBalanceCurrentNew();
                    newBalance = dataNew['balance'];
                }

                this.balanceCurrent = oldBalance;
                //let test = data['data'].balance;
                // show money if win
                // console.log('this.balanceCurrent 0',this.balanceCurrent)
                setTimeout(() => {
                    //if (Number(this.balanceCurrent.replace(/[,]/g, '')) < Number(data['data'].balance)) {
                    if (Number(oldBalance.replace(/[,]/g, '')) < Number(newBalance.replace(/[,]/g, ''))) {
                        this.moneyLostWin = Number(newBalance.replace(/[,]/g, '')) - Number(oldBalance.replace(/[,]/g, ''));
                        this.strWinorLost = '+';
                        this.effectShowHideByClass('.moneyLostWin', 'winMoney', 1000);
                        // this.balanceCurrent  = newBalance;
                    } else {
                        // if(Number(oldBalance.replace(/[,]/g, '')) == Number(newBalance.replace(/[,]/g, ''))){
                        // this.strWinorLost = '-';
                        // this.moneyLostWin = this.totalMoneyChip;
                        // console.log(' this.moneyLostWin', this.moneyLostWin);
                        // this.effectShowHideByClass('.moneyLostWin', 'betMoney', 1000);
                        // }
                        // this.moneyLostWin = Number(oldBalance.replace(/[,]/g, '')) - Number(newBalance.replace(/[,]/g, '')) ;
                        // this.moneyLostWin = Number(newBalance.replace(/[,]/g, '')) - Number(oldBalance.replace(/[,]/g, ''));
                        // console.log('this.moneyLostWin 1',this.moneyLostWin);
                        // console.log('this.totalMoneyChip 1',this.totalMoneyChip);
                        // if(this.moneyLostWin != 0 )
                        // this.strWinorLost = '-';
                        // this.effectShowHideByClass('.moneyLostWin', 'betMoney', 1000);
                    }
                    // ph 1
                    // this.resetDataChipBet();
                    // console.log('this.balanceCurrent 1',this.balanceCurrent)

                    this.balanceCurrent = this.commonSV.numberWithCommas(newBalance);
                    //  this.commonSV.numberWithCommas(data['data'].balance);
                    this.cancelbet(true);
                }, 1000);
                // end show money if win

                // effect bet win bg
                let detailArrWinBet = data['data'].details;
                for (let i = 0, len = this.getNameEachBet.length; i < len; i++) {
                    if (detailArrWinBet.indexOf(this.getNameEachBet[i]) > -1) {
                        let btnWin = this.pageDome.querySelector('button[data-name="' + this.getNameEachBet[i] + '"]');
                        btnWin.classList.add('activeWin');
                    }
                }
                setTimeout(() => {
                    let elChips = this.pageDome.querySelectorAll('.taixiuWrapper .button-ios');
                    for (let i = 0, len = elChips.length; i < len; i++) elChips[i].classList.remove('activeWin');
                }, 500);
                // end effect bet win bg

                this.getHistorys1Giay();
            }
        });

    }

    async getBalanceCurrentNew() {
        //    return  new Promise<void>((resolve, reject) => {
        return this.lotteryService.lotteryBalance({}, null)
        //     this.lotteryService.lotteryBalance({}, null).then(data => {
        //         if (data["balance"]) {
        //             this.balanceCurrent = this.commonSV.numberWithCommas(data['balance']);
        //             resolve(data['balance']);
        //         }
        //     });    
        // })


    }

    ngOnDestroy() {
        clearInterval(TaiXiuPage.countTimer);
        // this.events.unsubscribe('taixiu:trace');
        // this.events.unsubscribe('taixiu:CloseJumpEmu');
        // this.events.unsubscribe('taixiu:Clean');

    }



    toggleOpenRecordPanel() {
        this.openRecordPanelShow = !this.openRecordPanelShow;
    }

    checkMoneyTrace() {
        let flag = false;
        if ((Number(this.balanceCurrent.replace(/[,]/g, '')) + this.totalMoneyChip) < this.totalMoneyChip * this.goIssues.totalNum) {
            AppDialog.alert({
                alertCtrl: this.alertCtrl,
                message: "Số tiền còn lại không đủ cho <span class='color-red'>" + this.goIssues.totalNum + "</span> lượt nuôi"
            });
            flag = true;
        }
        return flag;
    }

    goRecordList() {
        let rootNav = this.app.getRootNav();
        console.log("vao his");

        if (RecordListPage.hasInit) {
            rootNav.pop();
        } else {
            rootNav.push(RecordListPage, {
                lotteryId: this.gameId,
                lotteryName: this.gameNameTitle
            });
        }
    }

    getOpenRecord(issue: string, requestNum: number) {
        requestNum++;
        if (requestNum > 5) {
            return;
        }
        let postData = {
            issue: issue,
            lotteryid: LotteryPage.lotteryId
        };
        this.lotteryService.getOpenWinRecored(postData, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                // if (LotteryPage.isSMorTD) {
                //     data["code"] = this.smWinNumberToArray(data["code"]);
                // }

                // let issueNew = issue;
                // if (!this.isXoSoNhanh) {
                //     issueNew = this.datePIPE.transform(issueNew, 'dd/MM/yyyy'); //this.datePIPE.transform(issueNew, 'dd/MM/yyyy');
                // }
                // this.openAnimation({
                //     nums: data["code"],
                //     issue: issueNew
                // });
            } else {
                setTimeout(() => {
                    this.getOpenRecord(issue, requestNum);
                }, 2000);
            }

            // setTimeout(() => {
            //     this.lotteryService.getBalance(data => {
            //         this.balance = data['balance'];
            //     });
            // }, 1000);
        });
    }

    removeAllEls(els) {
        for (let i = 0; i < els.length; i++) {
            els[i].remove();
        }
    }

    cancelbet(isSave: boolean) {
        try {


            this.totalMoneyChip = 0;
            const listChip = Array.from(document.querySelectorAll('.chipEmbed'));
            listChip.forEach(element => {
                element.classList.add('hideEffect');
            });
            this.timeoutHideChip = setTimeout(() => {
                
                listChip.forEach(element => {
                    if (document.querySelector('.cls-wrapper').hasChildNodes())
                        document.querySelector('.cls-wrapper').removeChild(element);
                });
            }, 1000);
            if (this.balanceCurrent != undefined) {
                this.balanceCurrent = this.commonSV.numberWithCommas(Number(this.balanceCurrent.replace(/[,]/g, '')) + this.totalMoneyChip);
            }

            this.resetDataChipBet();
        } catch (error) {
            console.log('====================================');
            console.log(error);
            console.log('====================================');
        }
        // this.modelList.forEach(model => model.currentBet = 0);
    }

}




// WEBPACK FOOTER //
// ./src/pages/TaiXiu/TaiXiuPage.ts